import { DRAGGABLE_TYPES } from "Common/componentUtils/constants";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import React, { useEffect, useMemo, useState } from "react";
import { SidebarMenuList } from "../../Common";
import buildDocumentObjectSidebarItems from "../utils/buildDocumentObjectSidebarItems";
import locale from "./tabObjects.locale";
import classNames from "classnames";
import { TextWidget } from "Components/optionForm";
import styles from "./tabObjects.module.css";
const filterButtons = [
    {
        location: "after",
        name: "settings-button",
        options: {
            icon: "icon-search-glass text-light-on-surface-variant icon-color-inherit font-bold font-h5",
            elementAttr: {
                class: classNames(styles["filter-icon"], "no-border bg-transparent p-0")
            },
            disabled: true,
            height: 32,
            width: 32
        }
    }
];
export default function TabObjects(props) {
    const [filteredText, setFilteredText] = useState();
    useEffect(() => {
        var _a;
        (_a = props.onInitialized) === null || _a === void 0 ? void 0 : _a.call(props);
    }, [props.onInitialized]);
    const sidebarMenuItems = useMemo(() => {
        if (!props.activeDocumentId || props.documentType !== DOCUMENT_TYPE.GRAPH)
            return [];
        return props.documentObjects
            ? buildDocumentObjectSidebarItems(props.documentObjects, DRAGGABLE_TYPES.DOCUMENT_OBJECT, props.readOnlyMode)
            : undefined;
    }, [props.documentObjects, props.activeDocumentId, props.documentType, props.readOnlyMode]);
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles["search-panel"] },
            React.createElement(TextWidget, { value: filteredText, onChange: setFilteredText, label: "\u041F\u043E\u0438\u0441\u043A", labelMode: "floating", height: 44, buttons: filterButtons })),
        React.createElement("div", { className: styles["list-container"] },
            React.createElement(SidebarMenuList, { bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: !props.activeDocumentId || props.documentType !== DOCUMENT_TYPE.GRAPH
                    ? locale.SELECT_DOCUMENT
                    : "", filterText: filteredText, sortBy: props.sortBy, sortOrder: props.sortOrder }))));
}
